import React, { useEffect, useState } from 'react';
import apiClient from '../utils/apiClient';

// This guide mirrors the Add Game documentation shown in the Manage tab.
const GameSubmissionGuide = () => {
  const [contact, setContact] = useState({ wechat: '', email: '' });
  useEffect(() => {
    apiClient.get('/site-contact').then((response) => setContact(response.data)).catch(() => undefined);
  }, []);
  return (
  <div className="doc-content game-submission-guide">
    <div className="doc-section">
      <h4>1. 平台：选择平台</h4>
      <p>选择您添加游戏所属的平台，例如：GBA</p>
    </div>
    <div className="doc-section">
      <h4>2. 使用非标准模拟器</h4>
      <p>如果不勾选此项，每个平台的游戏会以默认模拟器运行；对于IOS，Windows内置，其原理并非游戏模拟原游戏文件运行，而依靠复刻或重编译网页版游戏的板块，默认作为html处理。该选项一般不需要勾选，但如果您添加的rom需要与平台不同的模拟器来运行（举例：「半条命」归类为经典PC游戏更容易被检索，但此版本实为web而非DOS框架下的游戏），请勾选「使用非标准模拟器」为游戏指定模拟器，来覆盖我们的默认选项。</p>
    </div>
    <div className="doc-section">
      <h4>3. 标题</h4>
      <p>请根据本游戏的Wikipedia条目填写游戏的英文标题，对于中文标题，应当尽量选择在中国大陆流行的标题，若没有大陆译名，可以采用港台译名。如果游戏没有中文名，可自行翻译。对于在国外没有知名度的中国游戏，可不用填写英文名，只填写中文标题。对于于日本首发但从未在欧美地区发行的游戏，如果其有被广为接受的英文标题或拼写，该标题可以采用。</p>
    </div>
    <div className="doc-section"><h4>4. 描述</h4><p>描述一栏暂时无需填写。</p></div>
    <div className="doc-section">
      <h4>5. 额外提示</h4>
      <p>大部分游戏在平台中添加的“控制提示”已经足以提供，但如果本游戏有着特殊的操作须知项或建议，则在本处填写，将会在控制面板最上面显示。</p>
    </div>
    <div className="doc-section">
      <h4>6. 发行年份，开发商，发行商</h4>
      <p>请根据Wikipedia条目，填写游戏的发行年份（如果游戏在不同国家/地区有不同发行年份，请填写最早的发行年份），开发者与发行商（如果开发商与发行商有广为接受的中文译名，请使用中文名；如果没有正式中文译名，请统一使用英文名）。注意信息一定对应游戏的正确版本。对于参与游戏设计及开发的人明确少于等于三人的早期游戏，鼓励在开发者一栏填写具体人名，用分号隔开。如游戏在不同地区有不同发行商，则以“/”隔开全部列举。</p>
    </div>
    <div className="doc-section"><h4>7. 汉化组</h4><p>对于社区汉化版的游戏rom，请在此填写汉化组名称</p></div>
    <div className="doc-section">
      <h4>8. 加载名称与启动选项</h4>
      <p>为方便管理，游戏文件在上传后默认会自动更名。但对于基于mame模拟器内核的游戏，文件名对游戏正常运行起到重要作用，需在此填入游戏文件包含后缀名的完整名字（例如：<code>frogger.zip</code>），以保证游戏以其原文件名被加载。</p>
    </div>
    <div className="doc-section"><h4>9. 多人游戏支持</h4><p>站点支持同屏幕双控制器的主机游戏与可以局域网联机的DOS游戏。如果您上传的游戏为多人联机游戏，请勾选，系统会自动配置。</p></div>
    <div className="doc-section"><h4>10. 移动端优化</h4><p>使用EmulatorJS模拟器的主机或掌机游戏可以将该选项保留勾选。如是其他游戏则需要衡量移动端可否操控，特别是大部分没有专门配置的PC游戏，应被取消勾选。</p></div>
    <div className="doc-section"><h4>11. 标签系统</h4><p>目前标签系统仍未完全实施，请勾选1-2项相关的标签，不要过度勾选。</p></div>
    <div className="doc-section">
      <h4>12. 上传封面图</h4>
      <p>对于有容易识别的实体卡带等游戏载体的主机，倾向于使用载体的正面图片作为封面图。对于PC游戏等，使用盒子正面图作为封面图。对于街机游戏，倾向于使用其正面照片。对于flash游戏，采用其低清截图。</p>
      <p>对于有多地区或多版本的游戏，优先使用美国发行的图片作为封面图，若其没有在美国发行过，则使用其他版本。</p>
      <p>图片要求最长边分辨率像素不超过1200，最短边分辨率像素不低于300，格式使用jpg或png。如图片大小大于100kb，则建议勾选“tinypng压缩”选项。</p>
      <p>封面图推荐数据源为 <a href="https://gamesdb.launchbox-app.com" target="_blank" rel="noopener noreferrer">LaunchBox Games Database</a>。如无法找到，则推荐使用图片搜索，并用图片编辑工具调整角度、裁切与分辨率。</p>
    </div>
    <div className="doc-section">
      <h4>13. 上传游戏ROM和启动选项</h4>
      <p className="doc-warning">*请务必在添加任何条目后测试其可否正常运行</p>
      <p>您将在此处上传游戏ROM或者游戏依赖运行的文件或文件包。对于大部分游戏，可以检索“游戏名 + 平台 + rom”寻找合适版本，并明确标注版本。</p>
      <p>如果该游戏在多地区有明显不同的发行版本，推荐选择“多rom”模式并添加和标明版本。如游戏中有大量文本量，请尽可能同时上传汉化版ROM并致谢汉化组。</p>
      <ul>
        <li>Atari 2600：<code>.bin</code> <code>.a26</code></li>
        <li>Famicom / NES：<code>.nes</code> <code>.fds</code></li>
        <li>Mega Drive / Genesis：<code>.bin</code> <code>.md</code> <code>.gen</code></li>
        <li>Game Boy Advance：<code>.gba</code></li>
        <li>Apple II：<code>.woz</code></li>
        <li>SNES / Super Famicom：<code>.smc</code> <code>.sfc</code></li>
        <li>Game Boy：<code>.gb</code></li>
        <li>Virtual Boy：<code>.vb</code></li>
        <li>Nintendo 64：<code>.z64</code> <code>.n64</code> <code>.v64</code></li>
      </ul>
      <div className="doc-subsection"><h5>HTML游戏</h5><p>支持以单个html文件上传或以主html文件处于根目录的zip压缩包上传。zip包需要在“启动选项”中使用<code>--mainhtml=xxxx.html</code>指定主文件；可用<code>--resolution=????x???</code>设置分辨率。</p></div>
      <div className="doc-subsection"><h5>MAME游戏</h5><p>请在上传.zip格式rom的同时，在“加载名称”项填写含扩展名的完整文件名。</p></div>
      <div className="doc-subsection"><h5>DOS游戏</h5><p>请使用 <a href="https://dos.zone/studio-v8" target="_blank" rel="noopener noreferrer">DOS.Zone Bundle Creator</a> 创建符合 JS-DOS 格式的游戏包，并在创建过程中配置启动程序与所需的移动端控制。</p></div>
      <div className="doc-subsection"><h5>Flash游戏</h5><p>可上传.swf文件；多文件Flash游戏请将游戏内容在根目录重新压缩，并使用<code>--mainfile=xxx.swf</code>配置主文件。</p></div>
      <div className="doc-subsection"><h5>苹果II游戏</h5><p>目前仅支持单.woz格式的游戏，功能待扩充。</p></div>
    </div>
    <div className="doc-section">
      <h4>14. 上传游戏手册</h4>
      <p>请下载游戏手册的pdf文件，并在写清文件名后上传。一般可以检索“游戏名 + 平台名 + manual pdf”。</p>
      <p>如果pdf文件过大，请寻找pdf压缩网站压缩pdf后再上传，推荐使用 <a href="https://www.ilovepdf.com/compress_pdf" target="_blank" rel="noopener noreferrer">https://www.ilovepdf.com/compress_pdf</a>。上传pdf文件最大不得超过25mb。</p>
      <p>为了方便可读性，手册文件不允许两页在pdf中被扫描成一页；如有此情况，请先裁切与重新编排。</p>
    </div>
    <div className="doc-section doc-appendix">
      <h4>需要帮助？</h4>
      <p>如果在准备或提交游戏时有任何问题，请联系网站管理员：</p>
      <p>微信：<strong>{contact.wechat || '载入中…'}</strong><br />邮箱：<strong>{contact.email || '载入中…'}</strong></p>
    </div>
  </div>
  );
};

export default GameSubmissionGuide;
